import { render, staticRenderFns } from "./MyColor.vue?vue&type=template&id=f2207e86&scoped=true"
import script from "./MyColor.vue?vue&type=script&lang=js"
export * from "./MyColor.vue?vue&type=script&lang=js"
import style0 from "./MyColor.vue?vue&type=style&index=0&id=f2207e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2207e86",
  null
  
)

export default component.exports